import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import heroImg from '../assets/kashmir-scenic.jpg';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebase';
import { motion } from 'framer-motion';
import { FaFolderOpen, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';

import './Home.css';

const Home = () => {
  const [user] = useAuthState(auth);
   const [categories, setCategories] = useState([]); // ✅ For dropdown
  const [searchCategory, setSearchCategory] = useState('');
  const [searchLocation, setSearchLocation] = useState('');
  const [searchDate, setSearchDate] = useState('');
  const navigate = useNavigate();
const [showModal, setShowModal] = useState(false);
const [email, setEmail] = useState('');

  // ✅ Fetch categories
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/jobs/categories`)
      .then((res) => setCategories(res.data || []))
      .catch((err) => console.error('Error fetching categories:', err));
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams();
    if (searchCategory) queryParams.append('category', searchCategory);
    if (searchLocation) queryParams.append('location', searchLocation);
    if (searchDate) queryParams.append('date', searchDate);
    navigate(`/jobs?${queryParams.toString()}`);
  };
const handleSubscribe = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch(`${process.env.REACT_APP_FRONTEND_URL}/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (res.ok) {
      alert('✅ Subscribed successfully!');
      setShowModal(false);
      setEmail('');
    } else {
      alert(data.message || 'Something went wrong');
    }
  } catch (err) {
    console.error('❌ Subscription failed:', err);
    alert('Something went wrong.');
  }
};

  return (
    <div className="container py-5">

      {/* Hero Section */}
      <motion.div
        className="hero-section text-center mb-5 position-relative"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '12px',
          overflow: 'hidden',
          minHeight: '320px',
        }}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.55)',
            zIndex: 1,
          }}
        />
        <div style={{ position: 'relative', zIndex: 2, padding: '60px 20px' }}>
          <img src={logo} alt="Logo" className="mb-3 hero-logo" />
          <h1 className="fw-bold text-white display-5">Kashmir Jobs</h1>
          <p className="lead fw-semibold hero-tagline">
            SEARCH &amp; APPLY TO THE LATEST JOBS IN KASHMIR
          </p>
   {user && (
  <div className="mt-3 text-center">
    <Link
      to="/subscribe"
      className="subscribe-alert-btn"
    >
      📧 Subscribe to Daily Alerts
    </Link>
  </div>
)}


          {!user && (
            <div className="mt-3">
              <Link to="/register" className="btn btn-light fw-bold me-2">Get Started</Link>
              <Link
  to="/login"
  className="btn fw-bold"
  style={{
    color: 'white',
    border: '2px solid white',
    backgroundColor: 'transparent',
    padding: '8px 20px',
    transition: 'all 0.3s ease'
  }}
  onMouseOver={(e) => {
    e.currentTarget.style.backgroundColor = 'white';
    e.currentTarget.style.color = 'black';
  }}
  onMouseOut={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
    e.currentTarget.style.color = 'white';
  }}
>
  Login
</Link>

            </div>
          )}
        </div>
      </motion.div>

      {/* Search Section */}
      <motion.div
        className="section-box"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h4 className="section-heading text-center mb-4">Search Jobs</h4>
        
      <form className="row g-3 justify-content-center" onSubmit={handleSearch}>

  {/* 📂 Job Category */}
  <div className="col-md-3 position-relative">
    <label htmlFor="category" className="form-label fw-bold">
      <FaFolderOpen className="me-1 text-primary" /> Job Category
    </label>
    <select
      id="category"
      className="form-control ps-4"
      value={searchCategory}
      onChange={(e) => setSearchCategory(e.target.value)}
    >
      <option value="">All Categories</option>
      {categories.map((cat, index) => (
        <option key={index} value={cat._id}>
          {cat._id} ({cat.count})
        </option>
      ))}
    </select>
  </div>

  {/* 📍 Location */}
  <div className="col-md-3 position-relative">
    <label htmlFor="location" className="form-label fw-bold">
      <FaMapMarkerAlt className="me-1 text-danger" /> Location
    </label>
    <input
      type="text"
      id="location"
      className="form-control"
      placeholder="Enter location"
      value={searchLocation}
      onChange={(e) => setSearchLocation(e.target.value)}
    />
  </div>

  {/* 📅 Date */}
  <div className="col-md-3 position-relative">
    <label htmlFor="date" className="form-label fw-bold">
      <FaCalendarAlt className="me-1 text-success" /> Date
    </label>
    <input
      type="date"
      id="date"
      className="form-control"
      value={searchDate}
      onChange={(e) => setSearchDate(e.target.value)}
    />
  </div>

  {/* 🔍 Search Button */}
  <div className="col-md-2 d-flex align-items-end">
    <button type="submit" className="btn btn-success w-100">Search</button>
  </div>
</form>

      </motion.div>
      

      {/* ✅ Visible to both: CTA */}
      {/* ✅ Visible to both: CTA */}
{/* ✅ Visible to both: CTA */}
<motion.div
  className="section-box text-center mt-5"
  whileInView={{ opacity: 1, y: 0 }}
  initial={{ opacity: 0, y: 40 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6 }}
>
  <h4 className="section-heading mb-3" style={{ color: 'white' }}>
    ARE YOU LOOKING FOR A JOB?
  </h4>
  <div className="mt-3">
    <Link to="/jobs" className="btn btn-success fw-bold px-4 py-2">
      🔍 Click here to view all jobs
    </Link>
  </div>
</motion.div>


      <hr className="my-5" />

      {/* Trust Metrics */}
      <motion.div
        className="section-box trust-section text-center"
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 40 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h4 className="section-heading mb-4">Why JobSeekers Trust Us</h4>
        <div className="row justify-content-center">
          {[
            { value: '54000+', label: 'Instagram Followers' },
            { value: '15000+', label: 'Jobs Shared on Instagram' },
            { value: '5000+', label: 'Hired via Our Platform' }
          ].map((item, index) => (
            <div className="col-12 col-sm-6 col-md-4 mb-3" key={index}>
              <div className="bg-white p-4 rounded shadow-sm h-100 d-flex flex-column justify-content-center align-items-center">
                <h3 className="text-danger fw-bold mb-1">{item.value}</h3>
                <p className="mb-0">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-center flex-wrap gap-2 mt-3">
          <a
            href="https://www.instagram.com/kashmir_jobs"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-gradient btn-sm text-white"
          >
            📸 Follow Us on Instagram
          </a>
        </div>
      </motion.div>

      <hr className="my-5" />

      {/* Why Choose Kashmir Jobs */}
      <motion.div
        className="section-box text-center"
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: 40 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h4 className="section-heading mb-3">Why Choose Kashmir Jobs?</h4>
        <div className="row justify-content-center">
          {[
            '🚀 Fresh Jobs Posted Daily',
            '🆓 Feel Free to Post & Apply',
            '🌟 Diverse Job Opportunities',
            '📱 Seamless On All Devices'
          ].map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-3 mb-3">
              <div className="bg-white p-3 rounded shadow-sm h-100 fw-semibold text-start">
                {item}
              </div>
            </div>
          ))}
        </div>
      </motion.div>

      {/* Final CTA (only for guests) */}
      {!user && (
        <motion.div
          className="text-center mt-5"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h5>Ready to explore?</h5>
          <Link to="/register" className="btn btn-success mt-2">
            Join Kashmir Jobs Now
          </Link>
        </motion.div>
      )}
    </div>
    
  );
};

export default Home;
